module.exports = __webpack_public_path__ + "static/media/laboratorio.d3d30064.png";